export const AUDIT_ACTIONS = [
  "account.suspend",
  "account.unsuspend",
  "account.staff.set",
  "policy.set",
  "policy.delete",
  "owner.transfer",
  "entitlement.catalog.set",
  "entitlement.set",
  "entitlement.delete",
  "billing.checkout",
  "billing.entitlement.sync",
  "billing.revise",
  "billing.resume",
  "billing.band.drift",
  "billing.refund.revoked",
  "billing.pending.discarded",
  "billing.subscription.duplicate",
  "billing.payment_method.session",
  "billing.payment_method.default",
  "billing.payment_method.delete",
  "connection.public.register",
  "connection.public.adopt",
  "connection.public.fallback",
  "connection.custom.adopt",
  "tenant.showcase.set",
  "tenant.showcase.ban",
  "tenant.showcase.unban",
  "tenant.reprovision",
  "tenant.capture.verify",
  "tenant.deprovision",
  "tenant.rebind",
] as const;

export type AuditAction = (typeof AUDIT_ACTIONS)[number];
